<template>
  <div class="user"><span><router-link to="/profile">{{ user.NAAM }}</router-link></span></div>
</template>

<script>
import {mapActions} from "vuex";
export default {
  name: "User",
  created() {
    const user = this.$store.state.auth.user;
    if (user && user.TAAL){
      this.$i18n.locale = user.TAAL.toLowerCase();
    }
    else if(!user){
      this.logoutUser();
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods:{
    ...mapActions('auth', [
      'logout',
    ]),
    logoutUser(){
      this.logout();
    }
  }
}
</script>
